<template>
  <!--登记信息-->
  <CardView :schema="noteInfo" :sourceData="data" :column="2"></CardView>
</template>
<script>
import { CardView } from '@/lxfintech-fe-components'

export default {
  props: ['data'],
  components: { CardView },
  data() {
    return {
      noteInfo: {
        enterpriseName: {
          label: '公司名称',
        },
        unifiedSocialCreditCode: {
          label: '统一社会信用代码',
        },
        enterpriseType: {
          label: '公司类型',
        },
        operateStatus: {
          label: '经营状态',
        },
        legalRepresentative: {
          label: '法定代表人',
        },
        establishmentDate: {
          label: '成立日期',
        },
        registeredCapital: {
          label: '注册资本(万元)',
        },
        validityFromValidityTo: {
          label: '营业期限',
        },
        registrationInstitution: {
          label: '登记机关',
        },
        issueDate: {
          label: '发照日期',
        },
        telephone: {
          label: '联系电话',
        },
        industry: {
          label: '行业',
        },
        netWork: {
          label: '网址',
        },
        email: {
          label: '邮箱',
        },
        address: {
          label: '企业地址',
        },
        provinceCity: {
          label: '省份/市',
        },
        businessScope: {
          label: '经营范围',
        },
        businessAddress: {
          label: '经营地址',
        },
      },
      noteInfoData: {
        enterpriseName: '1',
        unifiedSocialCreditCode: '',
        enterpriseType: '',
        operateStatus: '',
        legalRepresentative: '',
        establishmentDate: '',
        registeredCapital: '',
        issueDate: '',
        telephone: '',
        industry: '',
        netWork: '',
        email: '',
        address: '',
        provinceCity: '',
        businessScope: '',
        businessAddress: '',
      },
    }
  },
  mounted() {},
  methods: {},
}
</script>
